import React from 'react';

import { navigate, url } from 'js/services/Network';

import Container from './Container';
import Buyer from './Buyer';
import Location from './Location';
import Price from './Price';
import Shipping from './Shipping';
import Buttons from './Buttons';
import Icon from './Icon';

export default ({ offer }) => (
  <Container onClick={() => navigate(url('manage-order-page', offer))}>
    <Buyer>{offer.buyer}</Buyer>
    <Location>{`${offer.delivery.city}, ${offer.delivery.state} ${offer.delivery.zip}`}</Location>
    <Price>{offer.item_price}</Price>
    <Shipping>{offer.shipping}</Shipping>
    <Buttons>
      <Icon name="chevron-right" />
    </Buttons>
  </Container>
);
